module.exports = __webpack_public_path__ + "static/media/silka-light-webfont.bd0f6baa.ttf";